'use strict'

export formatTimeLeft = (translator, formatter) ->
  (seconds) ->
    switch
      when isNaN seconds
        mnemonic = "##.TimeLeft.Unknown"
      when seconds is 0
        mnemonic = "##.TimeLeft.Ready"
      when seconds < 45
        num = Math.round(seconds)
        mnemonic = "##.TimeLeft.SecondsLeft"
      when seconds < 60
        mnemonic = "##.TimeLeft.LessThanOneMinute"
      when seconds < 45 * 60
        num = Math.round(seconds / 60)
        mnemonic = "##.TimeLeft.MinutesLeft"
      when seconds < 60*60
        num = 1
        mnemonic = "##.TimeLeft.LessThanOneHour"
      else
        num = Math.round(seconds / 1800) / 2
        mnemonic = "##.TimeLeft.AboutHoursLeft"

    # Obtain the translated message format
    formatter (translator mnemonic), {NUM: num}
